import getTradingCompanyName from './getTradingCompanyName';
import getOptionsTypeLabel from './getOptionsTypeLabel';
import type { Language } from '../types/common';
import type { OptionsType } from '../types/options';
import type { OrganizationType } from '../types/organization';

interface Options {
  organizationBases?: OptionsType[];
  tradingCompanies?: OptionsType[];
  language?: Language;
}

const defaultOption: Options = {
  organizationBases: undefined,
  tradingCompanies: undefined,
  language: undefined,
};

/**
 * 組織から組織の表示名を返す。該当する商社が見つからなかったら商社コードをそのまま帰す。
 * @param tradingCompanyCode [string]
 * @param option [Options]
 * @returns [string]
 */
const getOrganizationDisplayName = (organization: OrganizationType, option: Options = {}): string => {
  const mergedOption: Options = { ...defaultOption, ...option };
  // console.log(mergedOption);
  const { organizationBases, tradingCompanies, language } = mergedOption;
  const { tradingCompanyCode, organizationBaseId, organizationSuffixName } = organization;

  // 商社名
  const tradingCompanyName: string = getTradingCompanyName(tradingCompanyCode, { tradingCompanies, language });
  const displayedTradingCompany: string = tradingCompanies ? (tradingCompanyName !== '' ? ' (' + tradingCompanyName + ')' : '') : '';

  // 会社名
  const organizationBase: OptionsType | undefined = organizationBases?.find((base) => base.code === String(organizationBaseId));
  const displayedOrganizationBase: string = organizationBase ? getOptionsTypeLabel(organizationBase, language) : '';

  // 「会社名　組織詳細　商社名」の形にする
  const orgName: string = displayedOrganizationBase + ' ' + organizationSuffixName + displayedTradingCompany;
  return orgName;
};

export default getOrganizationDisplayName;
